import React from 'react'

import { useAppSelector } from '@app/app.hook'
import { selectStrings } from '@app/slices/slice.app'

import { IDS } from '@doc/constants'
import { PatientKeys, PatientValues } from '@doc/type'
import { FormikProps } from 'formik'

interface ComponentProps {
    readOnly: boolean
    patientEditFormik: FormikProps<Pick<
    PatientValues, 'firstName' | 'lastName' | 'email' | 'patientNumber'> & {active: boolean}>
    handleKeyDown: (
        e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>,
        fieldName?: PatientKeys
    ) => void
}

const LastName = ({ readOnly, patientEditFormik, handleKeyDown }:ComponentProps) => {
    const strings = useAppSelector(selectStrings)
    const fieldName: PatientKeys = 'lastName'

    const result = <div className={'form-group'}>
        <div className={'row mt-3 align-items-center'}>
            <div className={'col-3 d-none d-sm-block'}>
                <label htmlFor={IDS.PATIENT.EDIT.LAST_NAME}
                    className={'form-label'}>{
                        strings.doc?.text.patient.make_careplan.last_name
                    }</label>
            </div>
            <div className={'col-sm-9 col-12'}>
                <input
                    readOnly={readOnly}
                    type={'text'}
                    name={fieldName}
                    className={[
                        'form-control-sm',
                        readOnly ? 'form-control-plaintext' : 'form-control',
                        patientEditFormik.errors.lastName &&
                         'border-danger'
                    ].join(' ')}
                    placeholder={!readOnly ? strings.doc?.text.patient.make_careplan.last_name : ''}
                    value={patientEditFormik.values.lastName}
                    id={IDS.PATIENT.EDIT.LAST_NAME}
                    onBlur={patientEditFormik.handleBlur}
                    onChange={!readOnly ? patientEditFormik.handleChange : () => {}}
                    onKeyDown={handleKeyDown}
                    required
                />
                <div className={'form-text error'}>{
                    patientEditFormik.errors.lastName
                        ? patientEditFormik.errors.lastName
                        : null
                }</div>
            </div>

        </div>

    </div>

    return result
}

export default LastName
